import {useLuckySpinModal} from '@/common-pages/luckyspin/luckyspin.hooks';
import {postSpinConfig} from '@/common-pages/luckyspin/luckyspin.service';
import Tag from '@/components/basic/tag';
import {luckySpinIcon, MeListItem} from '@/components/business/list-item';
import globalStore from '@/services/global.state';
import {useLogin} from '@/utils/state-hooks';
import React, {useEffect, useState} from 'react';
import {useTranslation} from 'react-i18next';
import {Image} from 'react-native';

const MeListSpin = ({onRefresh}: {onRefresh?: () => void}) => {
  const {t} = useTranslation();
  const [innerHasFree, setInnerHasFree] = useState<boolean>(false);
  const login = useLogin();
  const getNavTag = (_hasFree: boolean) =>
    _hasFree ? <Tag content={'!'} /> : null;

  const onRefreshSpinConfig = () => {
    if (login) {
      postSpinConfig(true).then(data => {
        setInnerHasFree(!!data?.myFree);
      });
    } else {
      setInnerHasFree(false);
    }
    onRefresh?.();
  };
  const {renderModal: renderSpin, show: spinShow} = useLuckySpinModal({
    onNotice: onRefreshSpinConfig,
  });
  useEffect(() => {
    const sub = globalStore.tokenSubject.subscribe(token => {
      globalStore.asyncGetItem('luckyspinBackground').then(luckyspinBg => {
        if (luckyspinBg == null || luckyspinBg === '') {
          postSpinConfig(!!token).then(data => {
            Image.prefetch(data?.image);
            if (data?.image != null && data.image !== '') {
              globalStore.asyncSetItem('luckyspinBackground', data?.image);
            }
          });
        } else {
          Image.prefetch(luckyspinBg);
        }
      });
    });
    return () => {
      sub.unsubscribe();
    };
  }, []);

  useEffect(() => {
    onRefreshSpinConfig();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [login]);
  return (
    <>
      <MeListItem
        icon={luckySpinIcon}
        title={t('home.label.lucky-spin')}
        onPress={() => {
          spinShow();
        }}
        rightContent={getNavTag(innerHasFree)}
      />
      {renderSpin}
    </>
  );
};

export default MeListSpin;
